module.exports = __webpack_public_path__ + "static/media/crown.a10f0304.png";